import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  accordion: {
    backgroundImage: 'linear-gradient(to right, #4B2F61, #414B7A)',
  },
  title: {
    marginLeft: theme.spacing(4),
    fontSize: '1.1rem',
  },
}))

const PrivacyPracticesBlurb: React.FC<React.PropsWithChildren> = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <Accordion className={classes.accordion}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography className={classes.title}>
            {I18n.t('enrollment.dataPrivacy.title')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <List dense>
              <ListItem>
                <ListItemText>
                  <Typography variant="h6">
                    {I18n.t('enrollment.dataPrivacy.promoboxxDoesNot')}
                  </Typography>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {' '}
                  {I18n.t('enrollment.dataPrivacy.shareOrSellData')}
                </ListItemText>{' '}
              </ListItem>
              <ListItem>
                <ListItemText>
                  {I18n.t('enrollment.dataPrivacy.seeOrTrack')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {I18n.t('enrollment.dataPrivacy.postContent')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography variant="h6">
                    {I18n.t('enrollment.dataPrivacy.promoboxxDoes')}
                  </Typography>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {I18n.t('enrollment.dataPrivacy.adhereToSecurity')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Link
                    target="_blank"
                    href="https://gdpr-info.eu/"
                    color="inherit"
                    rel="noopener"
                    underline="always"
                  >
                    {I18n.t('enrollment.dataPrivacy.gdpr')}
                  </Link>
                  ,{' '}
                  <Link
                    target="_blank"
                    href="https://oag.ca.gov/privacy/ccpa"
                    color="inherit"
                    rel="noopener"
                    underline="always"
                  >
                    {I18n.t('enrollment.dataPrivacy.ccpa')}
                  </Link>
                  ,{' '}
                  <Link
                    target="_blank"
                    href="https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/"
                    color="inherit"
                    rel="noopener"
                    underline="always"
                  >
                    {I18n.t('enrollment.dataPrivacy.pipeda')}
                  </Link>{' '}
                  {I18n.t('enrollment.dataPrivacy.securityCompliant')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {I18n.t('enrollment.dataPrivacy.toLearnMore')}{' '}
                  <Link
                    target="_blank"
                    href="https://promoboxx.com/privacy"
                    color="inherit"
                    rel="noopener"
                    underline="always"
                  >
                    https://promoboxx.com/privacy
                  </Link>
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default PrivacyPracticesBlurb
